<template>
  <div class="hp_g_index">
      <div class="g_header">
          <div class="g_g">
              <div @click="gomap">
                  <van-image round width="0.63rem" height="0.63rem" src="https://oss.mcloud.moveclub.cn/mpms/20210311/1615439323-6049a5db9abc1.png" />
                  <span>红色足迹</span>
              </div>
              <div @click="gorank">
                  <van-image round width="0.63rem" height="0.63rem" src="https://oss.mcloud.moveclub.cn/mpms/20210311/1615439315-6049a5d3b44bb.png" />
                  <span>榜单</span>
              </div>
          </div>
          <div class="g_rule">
              <van-image width="0.35rem" height="0.37rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278644-604732349905a.png" />
              <span>详细活动规则请点击</span>
              <div class="mvbutton" @click="show=true">查看规则</div>
          </div>
          <div class="g_date">活动时间：{{matchinfo.start_time|startstate}}-{{matchinfo.end_time|endstate}}</div>
      </div>
      <div class="g_body">
          <div class="g_body_tit">百团之竞</div>
          <div class="g_body_notice">“百团之竞”第{{info.index|letters}}周数据（{{info.starttime|state}}~{{info.endtime|state}}）</div>
          <div class="g_medal">
              <div>
                  <span>{{myinfo.distance||0}}km</span>
                  <span>我的里程</span>
              </div>
              <div>
                  <span>{{myinfo.score||0}}%</span>
                  <span>我的完成率</span>
              </div>
              <div>
                  <span>{{groupinfo.distance||0}}km</span>
                  <span>团队里程</span>
              </div>
              <div>
                  <span>{{groupinfo.score||0}}%</span>
                  <span>团队完成率</span>
              </div>
          </div>
          <div class="g_body_btn">
              <div v-if="showtype===1" class="chou" @click="answer">去答题</div>
              <div v-if="showtype===2" class="chou" @click="goluck">好礼赢取</div>
              <div class="upload" @click="goto">去上传照片</div>
          </div>
      </div>
      <div class="g_main">
          <div class="g_m_h">点亮里程碑</div>
          <div class="swipe">
              <swiper class="swiper" :options="swiperOption" ref="mySwiper">
                    <swiper-slide class="swipe_item" v-for="item in srcList" :key="item.index">
                        <div class="tt" v-if="item.finish">
                            <van-image width="5.37rem" height="3.1rem" :src="item.imgurl" />
                            <div class="t_f"><span>第{{item.index|letters}}站</span> {{item.title}}</div>
                        </div>
                        <div class="t" v-else><span>第{{item.index|letters}}站</span> {{item.title}}</div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
          </div>
          <div class="g_s_notice">
              {{info.info}}
          </div>
          <div class="scroll">
            <div class="scroll_item" v-for="item in srcList" :key="item.index">
                <van-image v-if="item.finish" class="suo" width="1.42rem" height=".76rem" radius=".04rem" :src="item.imgurl" />
                <van-image v-else width="1.56rem" height=".9rem" radius=".04rem" src="https://oss.mcloud.moveclub.cn/mpms/20210311/1615462213-6049ff45d1afe.png" />
            </div>
          </div>
      </div>
      <Popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">
        <div class="vhtml" v-html="matchinfo.intro"></div>
      </Popup>
  </div>
</template>
<script>
import { Image, Popup,Dialog } from "vant";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import moment from "moment";

export default {
  components: {
    VanImage: Image,
    Popup,
    Swiper,
    SwiperSlide,
    Dialog
  },
  filters: {
    startstate(date) {
        if(date){
            return moment(date*1000).format("YYYY年M月D日");
        }else{
            return 'xx-xx';
        }

    },
    endstate(date) {
        if(date){
            return moment(date*1000).format("M月D日");
        }else{
            return 'xx-xx';
        }

    },
    state(date) {
        if(date){
            return date.slice(5,10);
        }else{
            return 'xx-xx';
        }

    },
    letters(e) {
      switch(e*1){
          case 1:
              return '一';
              break;
          case 2:
              return '二';
              break;
          case 3:
              return '三';
              break;
          case 4:
              return '四';
              break;
          case 5:
              return '五';
              break;
          case 6:
              return '六';
              break;
          case 7:
              return '七';
              break;
          case 8:
              return '八';
              break;
          case 9:
              return '九';
              break;
          case 10:
              return '十';
              break;
          case 11:
              return '十一';
              break;
          case 12:
              return '十二';
              break;
          case 13:
              return '十三';
              break;
          case 14:
              return '十四';
              break;

      }
    },
  },
  name: "hpIndex",
  computed: {
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 9,
        centeredSlides: true,
        initialSlide: 0,
        on: {
            // 监听滑动切换事件，返回swiper对象
            slideChange: () => {
                let swiper = this.$refs.mySwiper.$swiper;
                let i = swiper.activeIndex;
                this.changeData(i);
            }
        }
      },
      srcList: [],
      groupinfo: {},
      mylist: [],
      grouplist: [],
      myinfo: {},
      info: {},
      show: false,
      rules: '',
      matchinfo: {},
      index: '',
      showtype: 1,
      status: 0 //0:未开始，1:进行中，2:已结束
    };
  },
  methods: {
    init: function () {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0, // 持续展示 toast
      });
        this.$api.activity.hpGrmatch({matchid:this.$route.params.matchid}).then((res) =>{
            let {index,groupinfo,info,mylist,matchinfo} = res.data
            // this.swiperOption.initialSlide = 8;
            let sys_time = res.sys_time;
            if (sys_time < matchinfo.start_time*1) {
                this.status = 0;
            } else if (sys_time > matchinfo.end_time*1) {
                this.status = 2;
            } else {
                this.status = 1;
            }
            info.forEach((item)=>{
                let res = groupinfo.findIndex(io => { return io.index*1 === item.index*1&&io.state*1===1; });
                if(res !== -1){item.finish = true}
            })
            if(groupinfo.length===info.length){
                let ret = groupinfo.findIndex(item=>{return item.state*1===0});
                if(ret === -1){
                    this.showtype = 2
                }else{
                    this.showtype = 1
                }
            }else{
                this.showtype = 1
            }
            this.grouplist = groupinfo;
            this.matchinfo = matchinfo;
            this.mylist = mylist;
            this.index = index?index:1
            this.groupinfo = groupinfo.find(item=>{return item.index*1===index*1});
            this.myinfo = mylist.find(item=>{return item.index*1===index*1});
            this.info = info.find(item=>{return item.index*1===index*1});
            if(this.myinfo){
                if(this.myinfo.state*1===1){
                    this.myinfo.score = 100
                }else{
                  let score = 0;
                  if(this.myinfo.imageurl&&this.myinfo.imageurl != '') score += 33;
                  if(this.myinfo.distance*1>=3) score += 33;
                  if(this.myinfo.qstate*1 === 1) score += 33;
                  this.myinfo.score = score
                }

            }
            if(this.groupinfo){
              let num = this.groupinfo.finishnum*1
              let totalnum = this.groupinfo.totalnum*1
              this.groupinfo.score = parseInt(num/totalnum*100)

            }
            this.srcList = info
            if (window.__wxjs_is_wkwebview) {
              //部分ios
              window.scrollTo(0, 1);
            }
            this.changeData(0);
            this.$toast.clear();
        })
    },
    goluck() {
        if(this.status===0){
            Dialog.alert({
                title: '提醒',
                message: '活动暂未开始',
            }).then(() => {
            // on close
            });
            return;
        }
        this.$router.push({name:'hp_luckdraw', params: {acid:this.matchinfo.acid}})
    },
    gorank() {
        if(this.status===0){
            Dialog.alert({
                title: '提醒',
                message: '活动暂未开始',
            }).then(() => {
            // on close
            });
            return;
        }
        this.$router.push({name:'hp_rank', params: {matchid:this.$route.params.matchid}})
    },
    answer() {
        if(this.status===0){
            Dialog.alert({
                title: '提醒',
                message: '活动暂未开始',
            }).then(() => {
            // on close
            });
            return;
        }
        this.$router.push({name:'hp_question', params: {matchid:this.$route.params.matchid}})
    },
    gomap() {
        if(this.status===0){
            Dialog.alert({
                title: '提醒',
                message: '活动暂未开始',
            }).then(() => {
            // on close
            });
            return;
        }
        this.$router.push({name:'hp_map'})
    },
    goto() {
        if(this.status===0){
            Dialog.alert({
                title: '提醒',
                message: '活动暂未开始',
            }).then(() => {
            // on close
            });
            return;
        }
        this.$router.push({name:'hp_join', params: {matchid:this.$route.params.matchid,type:2}})
    },
    changeData(e){
        this.groupinfo = this.grouplist.find(item=>{return item.index*1===e*1+1})?this.grouplist.find(item=>{return item.index*1===e*1+1}):{};
        this.info = this.srcList.find(item=>{return item.index*1===e*1+1});
        this.myinfo = this.mylist.find(item=>{return item.index*1===e*1+1})?this.mylist.find(item=>{return item.index*1===e*1+1}):{};
        if(this.myinfo){
            if(this.myinfo.state*1===1){
                this.myinfo.score = 100
            }else{
                let score = 0;
                if(this.myinfo.imageurl&&this.myinfo.imageurl != '') score += 33;
                if(this.myinfo.distance*1>=3) score += 33;
                if(this.myinfo.qstate*1 === 1) score += 33;
                this.myinfo.score = score
            }

        }
        if(this.groupinfo){
          let num = this.groupinfo.finishnum*1
          let totalnum = this.groupinfo.totalnum*1
          this.groupinfo.score = parseInt(num/totalnum*100)

        }
    }
  },
//   created() {
//       this.init();
//   },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>

